// @flow

import React from 'react';
import styled from '@emotion/styled';
import { padding } from 'polished';

import Clickable from 'app/components/commons/Clickable';

type Props = {
  children: any,
  titleHeight?: number,
  title: string,
  titleStyle?: Object,
  onTitleClick?: () => void,
  renderLeftElement?: () => void,
  renderRightElement?: () => void
};

const defaultProps = {
  titleHeight: 48,
  titleStyle: undefined,
  onTitleClick: undefined,
  renderLeftElement: undefined,
  renderRightElement: undefined
};

const Wrapper = styled.div(({ theme }) => ({
  ...padding(theme.spacing.tiny, 0)
}));

const Title = styled(Clickable)(({ theme, titleHeight, style }) => ({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  textTransform: 'uppercase',
  color: 'white',
  backgroundColor: theme.color.basis1,
  ...padding(0, theme.spacing.small),
  height: titleHeight || 'inherit',
  ...style
}));

const Section = ({
  children,
  titleHeight,
  title,
  titleStyle,
  onTitleClick,
  renderLeftElement,
  renderRightElement
}: Props) => {
  const hasLeftElement = typeof renderLeftElement === 'function';
  const hasRightElement = typeof renderRightElement === 'function';

  return (
    <Wrapper>
      <Title
        hasRightElement={hasRightElement}
        titleHeight={titleHeight}
        style={titleStyle}
        onClick={onTitleClick}
      >
        {hasLeftElement && renderLeftElement()}
        <span>{title}</span>
        {hasRightElement && renderRightElement()}
      </Title>
      {children}
    </Wrapper>
  );
};

Section.defaultProps = defaultProps;

export default Section;
